<template>
  <div class="group-operation-block" :class="{ 'group-operation-block--invalid': props.error }">
    <div class="group-operation-block__title">
      <div class="paragraph-m font-600">
        <slot name="title" />
      </div>
      <e-btn variant="ghost" size="M" icon @click="emit('remove')">
        <e-icon name="closeSvg" size="20" />
      </e-btn>
    </div>
    <div class="group-operation-block__content">
      <slot />
    </div>
    <div v-if="props.error" class="group-operation-block__error">{{ props.error }}</div>
  </div>
</template>

<script setup lang="ts">
import { EBtn, EIcon } from '@/core/components/ui';

const props = defineProps<{
  error?: string;
}>();

defineSlots<{
  default: () => void;
  title: () => void;
}>();

const emit = defineEmits<{
  (event: 'remove'): void;
}>();
</script>

<style scoped lang="scss">
.group-operation-block {
  position: relative;

  border: 1px solid $border-color-light;
  border-radius: 16px;

  &__title {
    display: flex;
    justify-content: space-between;
    align-items: center;

    padding-left: 16px;
  }

  &__content {
    padding: 16px;
  }

  &__error {
    position: absolute;
    top: 100%;
    left: 16px;

    padding: 0 4px;

    font-size: 12px;
    line-height: 16px;
    font-weight: 600;
    color: $text-secondary-color;

    background-color: $primary-light-color;
    border-bottom-right-radius: 8px;
    border-bottom-left-radius: 8px;
  }

  &--invalid {
    background-color: $bg-light-color;
  }
}
</style>
